import React, { useCallback, useState } from 'react'
import useAuctionManager from '@hooks/useAuctionManager'
import { useMetaplexMetadata } from '@hooks/useMetaplexMetadata'
import { DewiCard } from '@containers/auction'
import BidItem from './BidItem'
import BidsDialog from './BidsDialog'
import { useRouter } from 'next/navigation'
import JazzIcon from '@components/JazzIcon'
import { useMediaQuery } from '@mui/material'

const AuctionBids = ({ currentDewiCat }: { currentDewiCat: DewiCard }) => {
  const { currentListing, bids } = useAuctionManager()
  const { image } = useMetaplexMetadata(currentListing?.tokenMint)
  const [showAllBids, setShowAllBids] = useState(false)

  const handleShowAllBids = useCallback(() => {
    setShowAllBids(true)
  }, [])

  const handleCloseAllBids = useCallback(() => {
    setShowAllBids(false)
  }, [])

  const isMobile = useMediaQuery('(max-width: 1024px)')

  return (
    <div className="flex flex-col gap-2 w-full">
      {/** Sort bids by highest amount and show first 3 */}
      <div className="flex flex-row gap-2 ml-2 xs:justify-center lg:justify-start">
        {bids
          ?.sort((a, b) => b.amount.toNumber() - a.amount.toNumber())
          .slice(0, isMobile ? 3 : 10)
          .map((bid, index) => {
            const translateX = index * 20
            return (
              <div
                key={bid.bidder.toBase58()}
                style={{
                  transform: `translateX(-${translateX}px)`,
                }}
              >
                <JazzIcon
                  className="flex items-center border-dark-6 border-[1px] rounded-full"
                  publicAddress={bid.bidder.toBase58()}
                  diameter={20}
                />
              </div>
            )
          })}
        {bids?.length ? (
          <span
            style={{
              transform: `translateX(-${(bids?.slice(0, isMobile ? 3 : 10)?.length - 1) * 20}px)`,
            }}
            className="text-size-2 text-gray-6"
          >{`${bids?.length} participants`}</span>
        ) : (
          <span className="w-32 h-4 mx-auto rounded bg-dark-7 animate-pulse text-xs" />
        )}
      </div>
      {/** View all Bids Text button */}
      {bids?.length > 0 && (
        <div className="flex w-full justify-center mt-4">
          <button
            onClick={handleShowAllBids}
            className="text-size-2 font-normal hover:text-gray-1 text-dark-1"
          >
            View all bids
          </button>
        </div>
      )}
      <BidsDialog
        currentDewiCat={currentDewiCat}
        open={showAllBids}
        onClose={handleCloseAllBids}
      />
    </div>
  )
}

const ProceedsToDeWiCatsTeamText = () => {
  const router = useRouter()

  const goToDeWiHallRoute = useCallback(() => {
    router.push('/dewihall')
  }, [router])

  return (
    <div>
      <div className="border-b border-b-gray-6 pb-4">
        <h4 className="text-size-2 text-gray-6">
          All DeWiCat auction proceeds are sent to{' '}
          <span className="font-bold text-blue-5">DeWiHall</span>. For this
          reason, we, the projects, founders{' '}
          {`('DeWiCats Inc.') have chosen to compensate
      ourselves with auction proceeds. Every 5th DeWiCats auction proceeds will
      be sent to the team where it will be used to support the project.`}
        </h4>
      </div>
      <div className="flex w-full justify-center mt-4">
        <button
          onClick={goToDeWiHallRoute}
          className="text-size-2 font-normal hover:text-gray-1 text-dark-1"
        >
          Learn more
        </button>
      </div>
    </div>
  )
}

export default AuctionBids
